import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import PutRequestComponent from '../../../components/Common/PutRequest';
const ActivateMembership = () => {
    const [url, setUrl] = useState('');
    const [requestBody, setRequestBody] = useState('');
    const [response, setResponse] = useState(null);
    const [breadcrumbItems] = useState([
      { title: 'Membership', link: '#' },
      { title: 'Activate Membership', link: '#' }
    ]);
    const headers=[
      {
        title:'apikey',
        type:'text',
        required:true,
      }
    ]
    const urlparams=[
      {
        title:'membership_id',
        type:'text',
        required:true
      }
    ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumbs
            title="Activate Membership Plan"
            breadcrumbItems={breadcrumbItems}
          />
          <p>To Activate a Purchased Membership for the Shop. Fields marked with <span style={{color:"red"}}>*</span> are required</p>
      <PutRequestComponent title="Activate Membership Plan" headers={headers} urlparams={urlparams} url='/v2/tp/membership/:membership_id/activate'/>
      </Container>
      </div>
    </React.Fragment>
  )
}

export default ActivateMembership;